module.exports = __webpack_public_path__ + "static/media/samsung-galaxy-buds-plus.f28f5397.png";